export function toPercentageString(value: number): string
{
	return (value * 100).toString() + '%';
}